import React, { useEffect } from "react"
import { graphql } from "gatsby"
import { Asset, Link } from "../../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import StructuredText from "../custom-structured-text-renderer"
import UseJobQuery from "../../../hooks/use-job-query"
import Select from "react-select"
import { Location, Check, RightArrow } from "../../icons"
import sal from "sal.js"

const AvailableJob = ({ title }) => {
  const jobs = UseJobQuery()

  return (
    <section className="available-job" id="jobs">
      <div className="available-job__inner">
        {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
        <div className="available-job__items">
          {jobs?.length > 0 && jobs.map((el, i) => (
            <div className="available-job__item" key={i} data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
              <div className="available-job__item-title">
                {el.venue.length > 0 && <Link to={el.venue[0].permalink}>{el.venue[0].title}</Link>}
                {el.title && <h4>{parse(el.title)}</h4>}
                {el.location && <span><Location />{el.location}</span>}
                {el.richContent && <StructuredText data={el.richContent} />}
              </div>
              <div className="available-job__item-features">
                {
                  el.keyFeatures?.length &&
                  <ul>
                    {
                      el.keyFeatures.map((el, i) => (
                        <li key={i}><Check /> {el.title}</li>
                      ))
                    }
                  </ul>
                }
                {el.permalink && <Link className="btn btn--border" to={el.permalink}>Apply Now <RightArrow /></Link>}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default AvailableJob

export const query = graphql`
  fragment AvailableJobProps on DatoCmsAvailableJob {
    ... on DatoCmsAvailableJob {
      id
      title
    }
  }
`